import React, {PureComponent, Fragment} from "react"
import {Route, Redirect} from "react-router"
import AuthApps from "@irati/auth/types/ReduxAuth/AuthApps"

import {IndexRedirect, NestedRoute, PartialRoute, withPartialRoute} from "@irati/utils/history/routing"
import AppContainer from "@irati/ui/src/AppContainer"
import authentication from "@irati/auth"
import {greys} from "@irati/ui/src/global/colors"
import {HasPermissionTo} from "@irati/utils/permissions"
import {isGlobalAdmin} from "@irati/identity/helpers/user/role"
import {FormattedMessage} from "@irati/utils/lang"

import Help from "../containers/Help/Help"
import Dashboard from "../containers/Dashboard"
import Billing from "../containers/Billing"
import Reporting from "./reporting"

import ProtectedTeamsSettings from "./protectedTeams"
import AdminSettings from "./adminSettings"
import UserSettings from "./userSettings"
import TeamSettings from "./teamSettings"
import {ADMIN_HOME, VIEW_BUSINESS_UNITS} from "./routeConfig"

interface Props {
  path: string
}

class AdminRoutes extends PureComponent<Props> {
  render() {
    const {path} = this.props
    const isAdmin = isGlobalAdmin(authentication.business(), authentication.user())

    if (!isAdmin) {
      return <FormattedMessage id="admin.noPermission" />
    }

    const admin: Partial<AuthApps> = authentication.apps("admin")
    const {people, teams, tenant} = admin

    return (
      <Route
        path={path}
        render={() => (
          <AppContainer addContentMarginTop disableMobile mainBackground={greys.white}>
            <HasPermissionTo permissions="admin">
              <NestedRoute component={() => <Fragment />} match={path} path="/" />
              <IndexRedirect match={{url: path}} to={ADMIN_HOME} />
              <NestedRoute component={Dashboard} useGrid={false} match={path} path={ADMIN_HOME} title="Admin Dashboard" />
              <NestedRoute component={ProtectedTeamsSettings} match={path} path="/countries" title="Countries" />
              <NestedRoute component={() => <Redirect to={`${path}${VIEW_BUSINESS_UNITS}`} />} match={path} path="/regions" />
              {people && <NestedRoute component={UserSettings} match={path} path="/people" title="Manage Users" />}
              {teams && <NestedRoute component={TeamSettings} match={path} path="/teams" title="Teams" />}
              {tenant && <NestedRoute component={AdminSettings} match={path} path="/settings" title="Settings" />}
              <PartialRoute match={path} path="/analytics" component={Reporting} title="Admin Analytics" />
              <PartialRoute match={path} path="/reporting" component={() => <Redirect to="/admin/analytics" />} />
              <NestedRoute component={Help} match={path} path="/help" title="Help" />
              <NestedRoute match={path} path="/billing" component={Billing} />
            </HasPermissionTo>
          </AppContainer>
        )}
      />
    )
  }
}

export default withPartialRoute(AdminRoutes)
